import {
  aCreateCustomMatchListColumn,
  aCustomMatchListColumn,
  mockCreateCustomMatchListColumnOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const createCustomMatchListColumnHandler = ({ id, fields, name }) => ({
  __typename: 'Mutation',
  createCustomMatchListColumn: aCreateCustomMatchListColumn({
    data: aCustomMatchListColumn({
      id,
      fields,
      name,
    }),
  }),
});

export const handlers = [
  mockCreateCustomMatchListColumnOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createCustomMatchListColumn: aCreateCustomMatchListColumn(),
        },
      });
    }
  ),
];
